import { formatDateTime } from '@collab/utils/formatters';

export type VolvoIdToken = {
  accessToken: string;
  expiresOn: string;
  expiresOnRaw: string;
};

export type AccessToken = {
  apiName: string;
  token: VolvoIdToken;
};

export type AccessTokenWithTitle = AccessToken & { apiDisplayName: string };

export const normalizeVolvoIdToken = (data: any): VolvoIdToken => ({
  accessToken: data.token.accessToken,
  expiresOn: formatDateTime(data.token.expiresOn),
  expiresOnRaw: data.token.expiresOn,
});
